<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		@if (signatureImage) {
			<div class="media-panel">
				<button type="button" class="media-panel-preview" (click)="openSignModal()">
					<img [src]="signatureImage" alt="" />
				</button>
				<button type="button" class="media-panel-action" (click)="openSignModal()">
					<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
						draw
					</span>
					{{ "SIGNATURE_QUESTION__RESIGN" | transloco }}
				</button>
			</div>
		} @else {
			<button type="button" class="action-panel" (click)="openSignModal()">
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					draw
				</span>
				<span class="action-panel-label">{{ "SIGNATURE_QUESTION__SIGN" | transloco }}</span>
			</button>
		}
		<app-file-upload [file$]="signatureFile$" [tags]="tags" (fileId)="setAnswers($event)"></app-file-upload>
	} @else {
		<app-file-upload [file$]="signatureFile$" [tags]="tags" (fileId)="setAnswers($event)">
			<ion-img *ngIf="signatureImage" [src]="signatureImage"></ion-img>
		</app-file-upload>

		<div class="button-container">
			<ion-button shape="round" color="primary" (click)="openSignModal()">
				<ion-icon slot="end" name="pencil-outline" />
				{{ "SIGNATURE_QUESTION__SIGN" | transloco }}
			</ion-button>
		</div>
	}
</app-question-template>
